import { FC } from "react";
import { useParams } from "react-router";
import { BoostingCampaign } from "@vviinn/user-managment-client-ts";
import { Rocket } from "lucide-react";

import {
  DetailedCard,
  DetailKeynote,
} from "../../../components/GeneralUI/DetailedCardComponents";
import { Badge } from "../../../ui/layout/molecules/Badge/Badge";
import { LARGE_ICON_SIZE_STYLES } from "../../../ui/styles";
import { STRATEGY_LABEL } from "../constants";

const BOOSTING_ICON_STYLES = (isActive: boolean) =>
  `${LARGE_ICON_SIZE_STYLES} ${isActive ? "text-green-100" : "text-white dark:text-stone-400"}`;

export type BoostingTileProps = {
  boosting: BoostingCampaign;
  isExtended: boolean;
  linkedServiceCount: number;
};

export const BoostingTile: FC<BoostingTileProps> = ({
  boosting,
  isExtended,
  linkedServiceCount,
}) => {
  const { id, name, column, scoreContributionStrategy, preferredValues } =
    boosting;
  const { companyId, siteId } = useParams();
  const isActive = linkedServiceCount > 0;

  return (
    <DetailedCard
      link={`/company/${companyId}/site/${siteId}/campaigns/boosting/${id}`}
      dataId={id}
      icon={<Rocket className={BOOSTING_ICON_STYLES(isActive)} />}
      title={name}
      permissions="campaign:basic_config:update"
      isExtended={isExtended}
      isActive={isActive}
      subtitles={[
        ...(column ? [{ type: "text" as const, text: column }] : []),
        ...(scoreContributionStrategy
          ? [
              {
                type: "text" as const,
                text: STRATEGY_LABEL[scoreContributionStrategy],
              },
            ]
          : []),
      ]}
    >
      <div className="mt-2 flex w-full flex-row flex-wrap gap-2">
        {isActive ? (
          <Badge
            type="neutral"
            title="linked campaigns"
            subtitle={String(linkedServiceCount)}
          />
        ) : (
          <Badge type="warning" title="No linked campaigns" />
        )}
      </div>
      <DetailKeynote
        items={preferredValues?.map((pv) => pv.value) ?? []}
        noItemsMessage="No preferred values"
      />
    </DetailedCard>
  );
};
